export const apolloURL = import.meta.env.VITE_GRAPHQL_URL;
export const adminApolloURL = import.meta.env.VITE_ADMIN_GRAPHQL_URL;
